import { createFileRoute } from '@tanstack/react-router';
import { PriceCorrectionPage } from '@features/admin/price-correction';

export const Route = createFileRoute('/admin/price-correction/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <PriceCorrectionPage />;
}
